module.exports = __webpack_public_path__ + "img/p1-pic.daf32cf3.jpg";